import * as actionTypes from './actionTypes'
import * as mutationTypes from './mutationTypes'
import { documentTypesApi } from '../../api/api.document.types.service'

export default {
  [actionTypes.GET_IMAGETYPE_FROM_DOCUMENTTYPE_DICT](store, documentTypeId) {
    if (
      store.getters.documentTypeImageTypeDict &&
      store.getters.documentTypeImageTypeDict[documentTypeId] !== undefined
    ) {
      return Promise.resolve()
    } else {
      return documentTypesApi.getImageTypes(documentTypeId).then(res => {
        return store.commit(mutationTypes.IMAGETYPE_FROM_DOCUMENTTYPE_UPDATED, {
          documentTypeId: documentTypeId,
          imageTypes: res,
        })
      })
    }
  },
}
